import * as moment from "moment";
import { Moment } from "moment";
import { DocumentClass } from "./documentClass";
import { Trademark } from "./trademark";
import { TrademarkFamily } from "./trademarkFamily";
import { ProductService } from "./productService";
import { Tag } from "./tag";
import { Note } from "./note";

export enum DocumentStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  ERROR = 'ERROR'
}

export enum DocumentType {
  PDF = 'application/pdf',
  PNG = 'image/png',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  TIFF = 'image/tiff'
}

export enum AnalysisMode {
  LIGHT = "LIGHT",
  FULL = 'FULL'
}

export enum Approval {
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PENDING = 'pending'
}

export enum BatchDocumentStatus {
  OK = 'OK',
  ERROR = 'ERROR',
  NO_TRADEMARK = 'NO_TRADEMARK',
  NO_TERRITORY = 'NO_TERRITORY',
  NO_DATE = 'NO_DATE',
  NO_NICE_CLASSIFICATION = 'NO_NICE_CLASSIFICATION',
  MISMATCH_NICE_CLASSIFICATION = 'MISMATCH_NICE_CLASSIFICATION',
  MISMATCH_TERRITORY = 'MISMATCH_TERRITORY'
}

export interface DocumentFilters {
  query?: string,
  approval: Approval[],
  classNumber: number[],
  territories: string[],
  documentClass: DocumentClass[],
  trademark: Trademark[],
  trademarkFamily: TrademarkFamily[],
  productsServices: ProductService[],
  nonUse?: boolean,
  isConfidential?: boolean,
  period: {
    start?: Moment,
    end?: Moment
  },
  tags: Tag[]
}

export interface Document {
  _id?: string;
  name: string;
  status: DocumentStatus;
  type?: DocumentType;
  class?: DocumentClass;
  pages?: number;
  size: number;
  confidential: boolean;
  nonUse: boolean;
  analysis?: AnalysisMode;
  approval?: {
    status?: Approval;
    date?: Moment;
    user?: {
      ref: string;
      firstName: string;
      lastName: string;
      avatar: string;
    };
  };
  documentKey?: string;
  batch: {
    ref: string;
    number: number;
    status: BatchDocumentStatus;
  };
  trademarks: {
    ref: string;
    name: string;
    identifierNumber: string;
    countryOfDesignation: string;
  }[];
  niceClassification: number[];
  productsServices?: {
    ref: string;
    label?: string;
    classNumber: number;
    trademark: string;
  }[];
  territories: string[];
  langs: string[];
  period?: {
    dates: Moment[];
    start: Moment;
    end: Moment;
  };
  users?: string[];
  timestamp?: Moment;
  orderPossibility?: boolean;
  uploader: {
    ref: string;
    firstName: string;
    lastName: string;
    avatar: string;
  };
  organizationId: string;
  technical: {
    cost: number;
    time: number;
    calls: string[];
    steps: string[];
    pagesNeeded: number;
  };
  createdAt: Moment;
  notes?: Note[];
  group?: string;
  versionNumber?: number;
}
